module.exports = __webpack_public_path__ + "media/images/3-ff032b62227d6d1e3e4d02241a882057.jpg";